export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
  /** 新版入口地址，可通过 VITE_NEW_VERSION_URL 覆盖。 */
  newVersionUrl: import.meta.env.VITE_NEW_VERSION_URL || 'https://test-creative.adesk.com/',
  casdoor: {
    serverUrl: import.meta.env.VITE_CASDOOR_SERVER_URL || '',
    clientId: import.meta.env.VITE_CASDOOR_CLIENT_ID || '',
    organizationName: import.meta.env.VITE_CASDOOR_ORGANIZATION_NAME || '',
    appName: import.meta.env.VITE_CASDOOR_APP_NAME || '',
    redirectUri: import.meta.env.VITE_CASDOOR_REDIRECT_URI || 'http://localhost:3000/callback',
  },
  s3: {
    readPrefix: import.meta.env.VITE_S3_READ_PREFIX || 'https://creative-s4.adesk.com/',
    oldReadPrefix: import.meta.env.VITE_S3_OLD_READ_PREFIX || 'https://creative-s3.adesk.com/creative-center/',
  },
};
